import { render } from "./FileDragAndDrop.vue?vue&type=template&id=0fd0d03f&scoped=true"
import script from "./FileDragAndDrop.vue?vue&type=script&lang=js"
export * from "./FileDragAndDrop.vue?vue&type=script&lang=js"

import "./FileDragAndDrop.vue?vue&type=style&index=0&id=0fd0d03f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd0d03f"]])

export default __exports__